import {useState } from 'react';
import { Box, Button, Stack, Typography } from '@mui/material';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';

import { Submit } from 'Input/Submit';
import { INPUT_STEP_NAMES, INPUT_STEPS } from 'Pages/Inputs/constants';

import { ValidatorContext } from 'Validation/ValidatorContext';
import { validatorManager } from 'Validation/validatorManager';

// export const ValidatorContext = createContext({
//   registerInputValidator: () => {},
//   getStepValidator: () => true,
//   getAllValidators: () => [],
// });

const InputsPage = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const [submitError, setSubmitError] = useState(null);

  const { registerInputValidator, getStepValidator, getAllValidators } = validatorManager;
  // const validatorManagerRef = useRef(null);
  // if (!validatorManagerRef.current) {
  //   validatorManagerRef.current = createValidatorManager();
  // }

  // const {
  //   registerInputValidator,
  //   getStepValidator,
  //   getAllValidators,
  // } = validatorManagerRef.current;

  // // Register an individual validator under a step and input key
  // const registerInputValidator = (stepName, inputName, validatorFn) => {
  //   // Get existing input validator map for this step
  //   const stepValidators = validatorMapRef.current.get(stepName) || new Map();
  
  //   // Set/replace the validator for the specific input name
  //   stepValidators.set(inputName, validatorFn);
  
  //   // Save back into the top-level map
  //   validatorMapRef.current.set(stepName, stepValidators);
  // };

  // // Get the validator for all inputs in the current step
  // const getStepValidator = (stepName) => {
  //   return () => {
  //     const stepValidators = validatorMapRef.current.get(stepName);
  
  //     if (!stepValidators || stepValidators.size === 0) return true;
  
  //     for (const [, validatorFn] of stepValidators.entries()) {
  //       try {
  //         const isValid = validatorFn();
  //         if (!isValid) {
  //           return false;
  //         }
  //       } catch {
  //         return false;
  //       }
  //     }
  
  //     return true;
  //   };
  // };

  // /**
  //  * Validates all registered input validators across all steps.
  //  *
  //  * @returns {Object} Result of validation:
  //  *   - { isValid: true } if all validations pass
  //  *   - { isValid: false, step: string, input: string } if a validation fails
  //  *   - { isValid: false, step: string, input: string, error: string } if a validation throws an error
  //  */
  // const getAllValidators = () => {
  //   const inputValidators = validatorMapRef.current;

  //   if (!inputValidators || inputValidators.size === 0) {
  //     return { isValid: true };
  //   }

  //   for (const [stepName, stepValidatorMap] of inputValidators.entries()) {
  //     for (const [inputName, validatorFn] of stepValidatorMap.entries()) {
  //       try {
  //         const isValid = validatorFn();
  //         if (!isValid) {
  //           return {
  //             isValid: false,
  //             step: stepName,
  //             input: inputName,
  //           };
  //         }
  //       } catch (error) {
  //         return {
  //           isValid: false,
  //           step: stepName,
  //           input: inputName,
  //           error: error.message || error.toString(),
  //         };
  //       }
  //     }
  //   }

  //   return { isValid: true };
  // }

  // get current input from URL path
  const inputUrl = location.pathname.split('/').pop();
  const currentInput = inputUrl === 'inputs' ? INPUT_STEP_NAMES.location : inputUrl
  const currentIndex = INPUT_STEPS[currentInput].index

  // are next / back actions valid?
  const hasNext = currentIndex < Object.keys(INPUT_STEPS).length - 1;
  const hasBack = currentIndex > 0;

  const handleNext = () => {
    const currentValidator = getStepValidator(currentInput);
    
    // Don't proceed if current step's validation fails
    if (!currentValidator()) {
      return;
    }
  
    if (hasNext) {
      const nextInput = Object.values(INPUT_STEP_NAMES)[currentIndex + 1];
      navigate(`/inputs/${nextInput}`);
    }
  }

  const handleBack = () => {
    if (hasBack) {
      const prevInput = Object.values(INPUT_STEP_NAMES)[currentIndex - 1];
      navigate(`/inputs/${prevInput}`);
    }
  }

  return (
    <ValidatorContext.Provider
      value={{
        registerInputValidator,
        getStepValidator,
        getAllValidators,
      }}
    >
      <Stack
        direction='row'
        spacing={3}
        useFlexGap
        sx={{ 
          height: '100%', 
          flexGrow: 1, 
          flexWrap: 'wrap', 
          justifyContent: 'center',
          alignContent: 'center',
        }}
      >
        {/* TODO: add progress / breadcrumbs here */}
        <Outlet />
      </Stack>
      
      {/* Fixed navigation footer */}
      <Box
        component='footer'
        gap={2}
        sx={{
          position: 'fixed',
          bottom: 0,
          left: 0,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          flexWrap: 'wrap',
          width: '100%',
          padding: 2,
          bgcolor: 'background.paper',
          boxShadow: 3,
        }}
      >
        <Stack direction='row' gap={2}>
          <Button disabled={!hasBack} color='secondary' variant='outlined' size='large' onClick={handleBack}>Back</Button>
          {hasNext && (
            <Button 
            color='primary' variant='contained' size='large' onClick={handleNext}>Next</Button>
          )}
          {/* TODO: show submit if all inputs are valid not just on last page? */}
          {!hasNext && (
            <Submit setError={setSubmitError} />
          )}
        </Stack>
        {submitError && (
          <Typography color='error' variant='body2'>
            {submitError}
          </Typography>
        )}
      </Box>
    </ValidatorContext.Provider>
  );
}

export default InputsPage;
